<template>
  <div id="app">
    <div v-if="user && user.playerAccountStatus === 'NOT_VERIFIED'" class="custom-toastr not-verified-user-toastr"
      :class="{ 'closed': notVerifiedToastrClosed }">
      <div class="activate-account-template">
        <p>
          {{ resendParagraphText }}
        </p>
        <button class="btn btn-type-2" type="button" :disabled="resendDisabled" @click="resendEmailConfirmation">
          {{ resendButtonText }}
        </button>
      </div>

      <button class="btn text-orange close-btn" type="button" @click="notVerifiedToastrClosed = true">
        x
      </button>
    </div>

    <component v-if="layout" :is="layout">
      <router-view></router-view>
    </component>
  </div>
</template>

<script>
import {
  TOASTER_SUCCESS,
  TOASTER_ERROR,
  TOASTER_INFO,
  TOASTER_WARNING
} from '@/common/events.types';
import STATUS_CODES from '@/common/statusCodes';
import { RESEND_EMAIL_CONFIRMATION, UPDATE_ACCOUNT_STATUS } from '@/store/action.types';
import {
  mapGetters,
  mapActions
} from 'vuex';
import { ACTIVE } from '@/constants/UserStatuses';
import { showSupportChat, hideSupportChat } from '@/common/supportChat';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.min.css';

export default {
  name: 'App',
  data() {
    return {
      resendTime: 60,
      resendDisabled: false,
      resendButtonText: 'Resend Activation Email',
      resendParagraphText: 'Your account is not yet activated. You need to confirm your email address.',
      resendInterval: null,
      notVerifiedToastrClosed: false,
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'account'
    ]),
    layout() {
      return this.$route.meta.layout
    }
  },
  methods: {
    ...mapActions({
      resendEmailConfirmationAction: RESEND_EMAIL_CONFIRMATION,
      updateUserStatusAction: UPDATE_ACCOUNT_STATUS
    }),
    resendEmailConfirmation() {
      this.resendDisabled = true;
      this.resendEmailConfirmationAction()
        .then(() => {
          this.resendInterval = setInterval(this.resendCounter, 1000)
        })
        .catch(error => {
          if (error.status.code === STATUS_CODES.BP_403) {
            this.$eventHub.$emit(TOASTER_ERROR, {
              message: this.$t('TOAST_MESSAGES.accountActivated')
            })
            this.updateUserStatusAction(ACTIVE)
          } else {
            this.$eventHub.$emit(TOASTER_ERROR, {
              message: this.$t('TOAST_MESSAGES.otherError')
            })
          }
        })
    },
    resendCounter() {
      this.resendTime--;
      this.resendButtonText = 'Please wait ' + this.resendTime + ' seconds';
      this.resendParagraphText = 'Activation email resent. Follow the instructions in the email to activate your account.';

      if (this.resendTime === 0) {
        clearInterval(this.resendInterval)
        this.resendButtonText = 'Resend Activation Email';
        this.resendDisabled = false;
        this.resendTime = 60;
      }
    }
  },

  mounted() {
    // Most views still emit toaster events instead of calling $toastr directly
    this.$eventHub.$on(TOASTER_SUCCESS, ({ title, message }) => {
      this.$toastr.s(message, title)
    })

    this.$eventHub.$on(TOASTER_ERROR, ({ title, message }) => {
      this.$toastr.e(message, title)
    })

    this.$eventHub.$on(TOASTER_WARNING, ({ title, message }) => {
      this.$toastr.w(message, title)
    })

    if (this.user && this.user.accountId) {
      showSupportChat(this.user)
    }

    if (this.user) {
      this.$i18n.locale = this.user.language ? (this.user.language).toLowerCase() : 'en';
    }
  },
  watch: {
    user(newUser) {
      if (newUser && newUser.accountId) {
        showSupportChat(newUser)
      } else {
        hideSupportChat()
      }
    },
    $route(to, from) {
      this.notVerifiedToastrClosed = false;
    },
  }
}
</script>

<style lang="scss">
@import './vendor/hamburgers.min.css';
@import '@/scss/helpers/index.scss';
@import '@/scss/components/index.scss';
@import '@/scss/responsive/index.scss';

.not-verified-user-toastr {
  position: fixed;
  padding: 10px;
  left: 0;
  right: 0;
  bottom: 10px;
  z-index: 9999999999;
  max-width: 700px;
  margin: 0 auto;
  background-color: $black;
  color: $elephant-gray;
  box-shadow: 0px 0px 17px 2px #f68d2e80;
  transition: bottom 0.5s;

  .close-btn {
    position: absolute;
    right: 0;
    top: 0;

    &:hover {
      color: $white;
    }
  }

  &.closed {
    bottom: -350px;
    transition: bottom 0.5s;
  }
}
</style>
